//--------- NODE MODULES CSS
//import 'bootstrap/dist/css/bootstrap.css';
import 'magnific-popup/dist/magnific-popup.css';

//--------- NODE MODULES JS
//import 'bootstrap';
//import '@fortawesome/fontawesome-free/js/all';

//--------- SITE JS
import './nav-tabs-cmg';
import './home-page';
import './brand-home-page';
import './careers';
import './find-loan/search-loan';
import './loan';
import './loan-tabs';
import './search-blog';
import './grant';
import './calculator/calculator-init';
import './correspondentcontact';
import './ourstory';
import './lo-bar';
import './corporateapplynow';
import './team';
import './partners';
import './true-partners';
import './common';
import './testimonial-video';
import './inputmask';
import './my-site-tab';
import './video-landing-page';
import './embedcode';
import './jvrecruiting-homepage';
import './recruiting-navigation';
import './rate-rebound';
import './lock-n-list';
import './lock-n-list-stripe';
import './listnlock-purchase';
import './recruiting-vip-video';

import $ from 'jquery';
import PageManager from './pageManager';

import SiteNavigator from './siteNavigator';

$(function () {
    new SiteNavigator();
    new PageManager();
});
